import { i as d, T as p, x as n, s as m } from "../../lit-element-6iugfgmM.js";
import { e as u } from "../../custom-element-wk-AooBb.js";
import { n as c } from "../../property-BWlAHqg_.js";
import "../../query-assigned-elements-B8U94KLQ.js";
import "../../sp-action-button-CjSKZ-qO.js";
import "@spectrum-web-components/icons-workflow/icons/sp-icon-heart.js";
import "../../sp-tooltip-RAJ82M3n.js";
import { Localize as v } from "../../lib/I18N.js";
import b from "../../events/FavoriteEvent.js";
const f = { "favorite-button.label": "Save to Favorites", "favorite-button.remove-label": "Remove from Favorites" }, g = d`:host{--highlighted-color: var(--spectrum-red-800)}@media (hover:hover){:host(:hover) sp-icon-heart{stroke:var(--highlighted-color)}}:host([selected]) sp-icon-heart{color:var(--highlighted-color);stroke:var(--highlighted-color)}sp-action-button{min-width:0}sp-action-button:hover,sp-action-button:focus{background:transparent}sp-icon-heart{color:transparent;stroke:var(--spectrum-gray-700);stroke-width:3px}`;
var k = Object.defineProperty, w = Object.getOwnPropertyDescriptor, h = (t, r, i, s) => {
  for (var a, o = s > 1 ? void 0 : s ? w(r, i) : r, l = t.length - 1; l >= 0; l--) (a = t[l]) && (o = (s ? a(r, i, o) : a(o)) || o);
  return s && o && k(r, i, o), o;
};
let e = class extends v(m, f) {
  constructor() {
    super(...arguments), this.selected = !1, this.showLabel = !1, this._renderTooltip = (t) => this._shouldHideTooltip() ? p : n`<sp-tooltip placement="top" self-managed>${t}</sp-tooltip>`, this._handleClick = () => {
      this.dispatchEvent(new b());
    };
  }
  static get styles() {
    return g;
  }
  render() {
    const t = this.selected ? this.t("favorite-button.remove-label") : this.t("favorite-button.label");
    return n`<sp-action-button @click="${this._handleClick}" label="${t}" quiet><sp-icon-heart slot="icon"></sp-icon-heart>${this.showLabel ? n`${t}` : p} ${this._renderTooltip(t)}</sp-action-button>`;
  }
  _shouldHideTooltip() {
    return this.showLabel;
  }
};
h([c({ type: Boolean })], e.prototype, "selected", 2), h([c({ type: Boolean })], e.prototype, "showLabel", 2), e = h([u("af-favorite-button")], e);
const C = e;
export {
  C as default
};
//# sourceMappingURL=FavoriteButton.js.map
